import { isDefined } from '@showroomjs/core';
import { Collapsible, styled, Table } from '@showroomjs/ui';
import * as React from 'react';
import snarkdown from 'snarkdown';
import { useTargetAudience } from '../lib/use-target-audience';
import { Div, H1, NavLink } from './base';
export const ComponentMeta = ({ componentData, propsDefaultOpen, slug, }) => {
    const [propsIsOpen, setPropsIsOpen] = React.useState(propsDefaultOpen);
    const targetAudience = useTargetAudience();
    const doc = componentData;
    const tags = doc.tags;
    return (React.createElement(React.Fragment, null,
        React.createElement(H1, null,
            React.createElement(NavLink, { to: `/${slug}`, css: Object.assign(Object.assign({}, (hasTag(tags, 'deprecated')
                    ? {
                        textDecorationLine: 'line-through',
                        fontWeight: 'normal',
                    }
                    : {})), { '&:hover': {
                        textDecoration: 'underline',
                    } }) }, doc.displayName)),
        doc.description && (React.createElement(Div, { dangerouslySetInnerHTML: {
                __html: snarkdown(doc.description),
            } })),
        targetAudience === 'developer' && (React.createElement(React.Fragment, null,
            React.createElement(ComponentMetaTags, { tags: tags }),
            React.createElement(ComponentPropsTable, { componentProps: doc.props, open: propsIsOpen, onOpenChange: setPropsIsOpen })))));
};
const ComponentPropsTable = (props) => {
    const componentProps = props.componentProps;
    if (Object.keys(componentProps).length === 0) {
        return null;
    }
    return (React.createElement(Collapsible.Root, { open: props.open, onOpenChange: props.onOpenChange, css: {
            marginY: '$4',
        } },
        React.createElement(Div, { css: { padding: '$1' } },
            React.createElement(Collapsible.Button, { css: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '$1',
                } },
                React.createElement(Collapsible.ToggleIcon, { hide: props.open, "aria-label": props.open ? 'Hide' : 'View', width: "16", height: "16" }),
                "Props")),
        React.createElement(Collapsible.Content, null,
            React.createElement(Table, null,
                React.createElement("thead", null,
                    React.createElement(Table.Tr, null,
                        React.createElement(Table.Th, null, "NAME"),
                        React.createElement(Table.Th, null, "TYPE"),
                        React.createElement(Table.Th, null, "DEFAULT"),
                        React.createElement(Table.Th, null, "DESCRIPTION"))),
                React.createElement("tbody", null, Object.keys(componentProps).map((prop) => {
                    const propData = componentProps[prop];
                    const isDeprecated = propData.tags && hasTag(propData.tags, 'deprecated');
                    const style = isDeprecated
                        ? { textDecorationLine: 'line-through' }
                        : undefined;
                    return (React.createElement(Table.Tr, { key: prop },
                        React.createElement(Table.Td, { css: style }, propData.name),
                        React.createElement(Table.Td, { css: style }, propData.type.raw),
                        React.createElement(Table.Td, { css: style }, propData.required ? (React.createElement(RequiredSpan, null, "Required")) : propData.defaultValue &&
                            isDefined(propData.defaultValue.value) ? (String(propData.defaultValue.value)) : ('-')),
                        React.createElement(Table.Td, { css: style, dangerouslySetInnerHTML: {
                                __html: snarkdown(propData.description),
                            } })));
                }))))));
};
const ComponentMetaTags = ({ tags }) => {
    const tagKeys = Object.keys(tags);
    return (React.createElement(React.Fragment, null, tagKeys.map((tag) => (React.createElement("p", { key: tag },
        React.createElement(React.Fragment, null,
            React.createElement(TagKey, { capitalize: tag === 'deprecated' }, tag),
            tags[tag] && typeof tags[tag] === 'string' && `: ${tags[tag]}`))))));
};
const RequiredSpan = styled('span', {
    color: '$gray-600',
});
const TagKey = styled('b', {
    variants: {
        capitalize: {
            true: {
                textTransform: 'capitalize',
            },
        },
    },
});
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasTag = (tags, tag) => hasOwnProperty.call(tags, tag);
//# sourceMappingURL=component-meta.js.map